module.exports = __webpack_public_path__ + "img/Swirls1264x898.4690d3ee.jpg";